import script from "./OptimizePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./OptimizePanel.vue?vue&type=script&setup=true&lang=js"

import "./OptimizePanel.vue?vue&type=style&index=0&id=5af138f6&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5af138f6"]])

export default __exports__